import { Field, useForm } from '@framework/ui/Organisms/FinalForm';
import Textarea from '@dealroadshow/uikit-textarea';
import ReCaptcha from '@framework/ui/Molecules/Form/ReCaptcha';
import RoadshowSharedPresentationField from '@evercall/call-form/ui/RoadshowSharedPresentationField';
import Question from './Question';

import CallEvent from '@evercall/domain/CallEvent';
import { CallEventType } from '@evercall/domain/vo/call/CallEventType';
import {
  TScheduleCallFormInitialValues,
  TScheduleCallFormValues,
} from '@/evercall/ui/components/ScheduleYourCall/interfaces';

import { mapOptionToValue } from '@framework/data-helpers/selectOptionMappers';
import { QUESTIONS_OACC, QUESTIONS_WEBINAR } from '@evercall/call-form/ui/constants';
import getQuestionTextValue from '@evercall/call-form/ui/helpers/getQuestionTextValue';
import { useCallFormContext } from '@evercall/call-form/ui/CallFormContext';

import styles from './stepFields.module.scss';

const AddOnsFields = () => {
  const form = useForm<TScheduleCallFormValues, TScheduleCallFormInitialValues>();
  const { values } = form.getState();
  const isWebinar = CallEvent.isWebinar(mapOptionToValue(values.eventTypeId) as CallEventType);
  const { instance } = useCallFormContext();

  return (
    <>
      <div className={ styles.questionFieldsWrp }>
        { isWebinar ? (
          <>
            <Question { ...QUESTIONS_WEBINAR.MP4 } />
            <Question { ...QUESTIONS_WEBINAR.WEB_REPLAY } />
            <div className={ styles.questionFieldHelper }>
              *Additional premium replay options available upon request
            </div>
            <Question { ...QUESTIONS_WEBINAR.CALL_TRANSCRIPTION } />
          </>
        ) : (
          <>
            <h3 className={ styles.questionTitle }>
              { getQuestionTextValue(QUESTIONS_OACC.ROADSHOW_SHARED_PRESENTATION.title, instance) }
            </h3>
            <div className={ styles.answersContainer }>
              <RoadshowSharedPresentationField />
            </div>
            <Question { ...QUESTIONS_OACC.SPEAKER_DASHBOARD } />
            <Question { ...QUESTIONS_OACC.CALL_RECORDING } />
            <Question { ...QUESTIONS_OACC.RECORDED_REPLAY } />
            <Question { ...QUESTIONS_OACC.CALL_TRANSCRIPTION } />
          </>
        ) }
      </div>
      <div className={ styles.additionalNotesContainer }>
        <Field
          name="additionalNotes"
          label={
            isWebinar
            ? 'additional notes'
            : 'additional notes (known speaker names, event includes in-person audience, anonymous q&a, etc.)'
          }
          textareaClassName={ styles.textarea }
          component={ Textarea }
          placeholder="Please provide additional details if applicable..."
          dataTest="evercallDetailsFormTextArea"
          isEnabledCountdownMessage
          maxLength={ 500 }
        />
      </div>
      <div className={ styles.recaptchaWrapper }>
        <Field
          name="recaptcha"
          className={ styles.recaptcha }
          component={ ReCaptcha }
        />
      </div>
    </>
  );
};

export default AddOnsFields;
